import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Wrench } from 'lucide-react';
import type { Mcp } from '@echo-work-platform/shared-types';
import { CrudTable, type Column } from '@/components/shared/crud-table';

const columns: Column<Mcp>[] = [
  { key: 'name', label: 'Név' },
  { key: 'url', label: 'URL' },
  {
    key: 'tools',
    label: 'Toolok',
    width: '8rem',
    render: (m) => (
      <Link
        to={`/mcps/${m.id}/tools`}
        className="inline-flex items-center gap-1 text-accent-700 hover:underline"
      >
        <Wrench className="h-4 w-4" /> Toolok
        {m.toolsDiscoveryError && (
          <span title={m.toolsDiscoveryError} className="text-rose-600">
            ⚠
          </span>
        )}
      </Link>
    ),
  },
];

function McpForm({
  initial,
  onSubmit,
  onCancel,
}: {
  initial: Partial<Mcp> | null;
  onSubmit: (v: Partial<Mcp>) => void;
  onCancel: () => void;
}): JSX.Element {
  const { register, handleSubmit } = useForm<Partial<Mcp>>({
    defaultValues: { name: initial?.name ?? '', url: initial?.url ?? '' },
  });
  return (
    <form className="space-y-4" onSubmit={(e) => void handleSubmit((v) => onSubmit(v))(e)}>
      <div>
        <label className="label">Név</label>
        <input className="input" {...register('name', { required: true })} />
      </div>
      <div>
        <label className="label">URL</label>
        <input className="input" {...register('url', { required: true })} placeholder="https://..." />
      </div>
      <p className="text-xs text-muted-foreground">
        Csak remote HTTP integrációk támogatottak (Claude.ai "custom connector" stílus).
      </p>
      <div className="flex justify-end gap-2">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Mégse
        </button>
        <button type="submit" className="btn-action">
          Mentés
        </button>
      </div>
    </form>
  );
}

export function Mcps(): JSX.Element {
  return (
    <CrudTable<Mcp>
      title="Integrations"
      endpoint="/api/admin/mcps"
      columns={columns}
      itemTitle={(m) => m.name}
      renderForm={(i, s, c) => <McpForm initial={i} onSubmit={s} onCancel={c} />}
    />
  );
}
